import BEMHelper from 'react-bem-helper';

export const bem = BEMHelper({ name: 'MTTab', outputIsString: true });
